
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M26.667 4H5.333a2.667 2.667 0 00-2.666 2.667v16a2.667 2.667 0 002.666 2.666h6.787c.35.002.685.14.933.387l1.987 1.987c.187.187.442.293.707.293h.506c.265 0 .52-.106.707-.293l1.987-1.987c.248-.246.583-.385.933-.387h6.787a2.667 2.667 0 002.666-2.666v-16A2.666 2.666 0 0026.667 4zm0 18.667H19.88a4 4 0 00-2.827 1.173L16 24.893l-1.053-1.053a4.002 4.002 0 00-2.827-1.173H5.333v-16h21.334v16zm-18-4H18a.667.667 0 00.667-.667v-1.333A.667.667 0 0018 16H8.667a.667.667 0 00-.667.667V18c0 .368.298.667.667.667zm0-5.334h14.666a.666.666 0 00.667-.666v-1.334a.667.667 0 00-.667-.666H8.667a.666.666 0 00-.667.666v1.334c0 .368.298.666.667.666z"}})])
          )
        }
      }
    